<template lang="pug">
  div(v-if="historyDetail")
    .flex.pl-48.justify-between.mt-24
      .flex.mb-12.items-center
        .cursor-pointer(@click="goBack" class="text-main-0")
          iCon.h-24.w-24(:iconClass="'ico_System back_black'" type="svg")
        span.ml-16.fontsize-20.font-700.text-24 {{historyDetail.data.filename}}
      .flex.mr-48
        div(@click="exportModal=true")
          iCon.h-24.w-24.mr-24.cursor-pointer(:iconClass="'Ico_Download'" type="svg")
        div(@click="deleteModal=true")
          iCon.h-24.w-24.cursor-pointer(:iconClass="'Ico_Delete'" type="svg" )
    .text-grey-66.mb-16.flex.justify-start.pl-88 {{ timeChange }}
    hr.border-t-2.mb-60.max-w-952.ml-48.mr-48
    .max-w-872.ml-88.mr-88
      .relative.flex
        hr.border-t-2.my-8.w-full.absolute.top-0
        span.text-left.font-700.text-20.bg-white.z-100  {{$t('__c6N3.__details')}}
      .my-24.font-700.flex.justify-start {{$t('__c6N3.__updateSetting')}}
      .mb-24.flex.justify-start.ml-48
        span.w-160.text-left.mr-32 {{$t('__c6N3.__frequency')}}
        span.text-grey-66 {{ historyAutoCheckFrequency(historyDetail.data.auto_check_frequency)}}{{historyDetail.data.day !== null ? `, ${historyDetailDay(historyDetail.data)}`:null}}{{historyDetail.data.time? `, ${historyDetail.data.time.substring(0, historyDetail.data.time.length - 3)}`: ''}}
        span.text-grey-66(v-if="historyDetail.data.is_local_time == false")   ；{{$t('__c6N3.__syncAllTimeZones')}}
      .mb-24.flex.justify-start.ml-48
        span.w-160.text-left.mr-32 {{$t('__c6N3.__updateBehavior')}}
        span.text-grey-66 {{ historyUpdateBehavior(historyDetail.data.update_behavior) }}
        span.text-grey-66(v-if="historyDetail.data.behavior_is_pause_disabled")   ；{{$t('__c6N3.__allowUserToPauseUpdates')}}
      .my-24.font-700.flex.justify-start {{$t('__c6N3.__updateFilters')}} 
      .mb-24.flex.justify-start.ml-48
        span.w-160.text-left.mr-32 {{$t('__c6N3.__driver')}} / {{$t('__c6N3.__firmware')}}
      .mb-24.flex.justify-start.ml-88
        span.w-160.text-left.mr-2 {{$t('__c6N3.__severity')}}
        span.text-grey-66 {{resultListItem(historyDetail.data.severity)}}
      .mb-48.flex.justify-start.ml-88
        span.min-w-160.text-left.mr-2 {{$t('__c6N3.__category')}}
        span.text-grey-66.max-w-632.text-left {{ categoryData }} 
      .mb-24.flex.justify-start.ml-48
        span.w-160.text-left.mr-32 {{$t('__c6N3.__windowsKb')}}
        span.ml-10.text-grey-66(v-if="!windowsKBData.length") {{$t('__c6N3.__exclude')}} WinKB
      div(v-if="windowsKBData.length")
        .mb-24.flex.justify-start.ml-88
          span.min-w-160.text-left.mr-2 {{$t('__c6N3.__severity')}}   
          span.text-grey-66 {{resultWinKBListItem(historyDetail.data.windows_kb_severity)}}
        .mb-48.flex.justify-start.ml-88
          span.min-w-160.text-left.mr-2 {{$t('__c6N3.__category')}}
          span.text-grey-66.max-w-632.text-left {{windowsKBData}}
    Modal.z-600(
      :show="exportModal" 
      :clickOutSideClose="false" 
      @closeModal="exportClose" 
      :header="'header'"
      :body="'footerBody'" 
      footer="footer"  
      )
      template(#header)
        .text-left.text-18.text-main-0.font-600.mt-22 {{$t('__e5H7.__export')}} 
      template(#footerBody)
        .mt-24.w-420.m-auto
          .row.my-20
            label.font-500.min-w-200.inline-block.text-16.mr-16
              span {{$t('__e5H7.__pleaseNameForYourFile')}}
            .w-full.mt-36
              Input.mr-10.w-420(type="text" @onKey="versionValid" :maxLength="'50'" :error="errorFileName" v-model="fileName" :placeholder="'Please input File name here'" )
      template(#footer)
        .flex.justify-center.mt-56
          Button.w-140.mr-20(:text="$t('__globeButton.__cancel')" type="borderSolid"  @buttonClick='exportClose()')
          Button.w-140(:text="$t('__globeButton.__export')"  type="normal" :disable="errorFileName != ''|| !fileName" @buttonClick='exportFile()')
    Modal.z-600(
      :show="deleteModal" 
      :clickOutSideClose="false" 
      @closeModal="deleteClose" 
      :header="'header'"
      :body="'footerBody'" 
      footer="footer"  
      )
      template(#header)
        .text-center.text-18.text-main-0.font-600.mt-22 {{$t('__e5H7.__deleteSelectedConfig')}}
      template(#footerBody)
        .mt-24.w-420.m-auto.text-center
          .row.my-20
            label.font-500.min-w-200.inline-block.text-16.mr-16
              span {{$t('__e5H7.__yourConfigWillBePermanentlyDeleted')}}
      template(#footer)
        .flex.justify-center.mt-56
          Button.w-140.mr-20(:text="$t('__globeButton.__cancel')" type="borderSolid"  @buttonClick='deleteModal=false')
          Button.w-140(:text="$t('__e5H7.__delete')"  type="normal"  @buttonClick='deleteFile()')
    Toast(:show.sync="toast" :text="$t('__common.__success')")
</template>
<script>
import moment from "moment";

import { configurationItem, configurationDelete } from "@/api/configuration.js";
import { exportHistory } from "@/api/export.js";

import Modal from "@/components/Modal.vue";
import Button from "@/components/Button.vue";
import Toast from "@/components/Toast.vue";
import Input from "@/components/Input.vue";

import { PAGEINDEX, DRIVERCATEGORYSTORE, DRIVERWINDOWSKBSTORE } from "@/enum/global";
import { WEEKSTRING } from "@/enum/global";

export default {
  name: "New",
  data() {
    return {
      historyDetail: null,
      categoryArray: [],
      deleteModal: false,
      toast: false,
      exportItem: {},
      exportModal: false,
      fileName: "",
      errorFileName: ""
    };
  },
  components: {
    Modal,
    Toast,
    Button,
    Input
  },
  async mounted() {
    const id = this.$route.params.id;
    const sendData = { id: id };
    try {
      const data = await configurationItem(sendData);
      if (data) {
        this.historyDetail = data;
        this.categoryArray = data.data.category;
        this.fileName = data.data.filename;
      }
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    resultListItem(e){
      let severityList = {
        HIGH : '__c6N3.__urgent',
        MEDIUM : '__c6N3.__recommend',
        LOW : '__c6N3.__optional',
      }
      let result = []
      let temp = []
      for (let i = 0; i < e.length; i++) {
        temp.push(this.$t(severityList[e[i]]));
      }
      temp = temp.filter(n => n)
      result = temp.join(', ')
      return  result
    },
    resultWinKBListItem(e){
      let severityList = {
        "EXTRA HIGH" : '__c6N3.__extrahigh',
        HIGH : '__c6N3.__high',
        NORMAL : '__c6N3.__normal',
        LOW : '__c6N3.__low',
      }
      let result = []
      let temp = []
      for (let i = 0; i < e.length; i++) {
        temp.push(this.$t(severityList[e[i]]));
      }
      temp = temp.filter(n => n)
      result = temp.join(', ')
      return  result
    },
    historyDetailDay(e) {
      let weekList = {
        Sunday: "__common.__sunday",
        Monday: "__common.__monday",
        Tuesday: "__common.__tuesday",
        Wednesday: "__common.__wednesday",
        Thursday: "__common.__thursday",
        Friday: "__common.__friday",
        Saturday: "__common.__saturday"
      };
      if (e.auto_check_frequency == "Weekly") {
        return this.$t(weekList[WEEKSTRING[e.day]]);
      } else {
        return e.day;
      }
    },
    historyUpdateBehavior(e) {
      if (e == "NotifyOnly") {
        return this.$t("__c6N3.__notifyOnly");
      } else  {
        return this.$t("__c6N3.__downloadInstall");
      }
    },
    historyAutoCheckFrequency(e) {
      if (e == "Manual") {
        return this.$t("__c6N3.__manual");
      } else if (e == "Weekly") {
        return this.$t("__c6N3.__weekly");
      } else {
        return this.$t("__c6N3.__monthly");
      }
    },
    goBack: function() {
      this.$router.go(-1);
    },
    deleteClose() {
      this.deleteItem = {};
      this.deleteModal = false;
      this.errorFileName = "";
    },
    async deleteFile() {
      const id = this.$route.params.id;
      const sendData = { id: id };
      console.log("deleteFile")
      try {
        await configurationDelete(sendData);
        this.$router.push({
          name: PAGEINDEX.EXPORTHISTORY
        });
      } catch (error) {
        console.log(error);
      }
    },
    openExport(e) {
      this.exportItem = e;
      this.exportModal = true;
    },
    exportClose() {
      this.exportItem = {};
      this.exportModal = false;
      this.errorFileName = "";
    },
    async exportFile() {
      let filename = this.fileName;
      let id = this.historyDetail.data.id.toString();
      const sendData = {
        filename: filename
      };
      try {
        const { data } = await exportHistory(id, sendData);
        this.downloadFile(data, filename);
      } catch (error) {
        this.apiError = error.response.status;
      }
      this.exportClose();
    },
    async downloadFile(blob, filename) {
      // let clean = encodeHTML(url) //安全性轉
      // window.location = clean;
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.setAttribute("rel", "noopener"); //安全性問題預防
      link.href = url;
      link.setAttribute("download", `${filename}.config`); //or any other extension
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      this.toast = true;
    },
    versionValid() {
      if (this.fileName) {
        // console.log('match', !/^[A-Za-z][A-Za-z0-9]*$/.test(this.fileName) )
        if (!this.fileName.match(/^[\w\-(){}A-Za-z0-9.]+$/)) {
          this.errorFileName = this.errorValidFileName;
        } else {
          this.errorFileName = "";
        }
      }
    }
  },
  computed: {
    categoryData: function() {
      let str = `${this.categoryArray[0]}` || null;
      for (let i = 1; i < this.categoryArray.length; i++) {
        let a = this.$t(`__c6N3.${DRIVERCATEGORYSTORE[this.categoryArray[i]]}`)
        str += ` / ${a}`;
        
      }
      return str;
    },
    windowsKBData: function() {
      let str = ''
      let temp = []
      for (let i = 0; i < this.historyDetail.data.windows_kb_category.length; i++) {
        let a = this.$t(DRIVERWINDOWSKBSTORE[this.historyDetail.data.windows_kb_category[i]]);
        temp.push(a);
      }
      temp = temp.filter(n => n)

      if(this.historyDetail.data.windows_kb_category.length){
        str = (this.$t(temp).join(' / '));
        // str = this.historyDetail.data.windows_kb_category.join(' / ');
      }
      return str;
    },
    timeChange: function() {
      let time = moment(
        this.historyDetail.data.created_time.replace(/ /g, ""),
        moment.ISO_8601
      ).format("YYYY/MM/DD A HH:mm");
      return time;
    }
  }
};
</script>

<style lang="scss" scoped></style>
